// CB-CONV §2: the client learns its environment from environment variables only. Vite inlines
// VITE_* at build time, so each environment gets its own build — there is no runtime config file to
// fetch, and no way for a built bundle to be pointed at a different API by accident.
//
// Validated once, at module load, so a missing variable is a blank page with a clear console error
// rather than a screen that renders and then fails on the first request.

export interface WebEnv {
  readonly apiBaseUrl: string;
  readonly userPoolId: string;
  readonly userPoolClientId: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is not set. The web client is built per environment; see apps/web/README.md.`,
    );
  }
  return value;
}

export function readEnv(source: ImportMetaEnv = import.meta.env): WebEnv {
  const apiBaseUrl = required('VITE_API_BASE_URL', source['VITE_API_BASE_URL']);
  const userPoolId = required('VITE_COGNITO_USER_POOL_ID', source['VITE_COGNITO_USER_POOL_ID']);

  // The pool id encodes its region, and the API's config validates the same shape. Checking it here
  // turns a typo into a startup error rather than an opaque failure inside the auth library.
  if (!/^[a-z]{2}-[a-z]+-\d_[A-Za-z0-9]+$/.test(userPoolId)) {
    throw new Error(`VITE_COGNITO_USER_POOL_ID is not a pool id: "${userPoolId}"`);
  }
  // Trailing slashes produce doubled separators in every request path.
  if (apiBaseUrl.endsWith('/')) {
    throw new Error(`VITE_API_BASE_URL must not end with a slash: "${apiBaseUrl}"`);
  }

  return {
    apiBaseUrl,
    userPoolId,
    userPoolClientId: required('VITE_COGNITO_CLIENT_ID', source['VITE_COGNITO_CLIENT_ID']),
  };
}

export const env = readEnv();
